import React from 'react';
import { motion } from 'framer-motion';
import { HERO_BADGES, MONTHLY_PRICE, SETUP_PRICE, formatEuro } from './offerData';
import { PRIMARY_CTA_CLASS, SECONDARY_CTA_CLASS } from './ctaStyles';
import { OfferFormCta, OfferWhatsAppCta } from './OfferCtaButtons';

const OfferHero: React.FC = () => (
  <div className="relative py-20 md:py-24 min-h-[520px] flex items-center overflow-hidden bg-surface">
    <div className="absolute inset-0 z-0">
      <img
        src="/images/heroes/website-hero.webp"
        alt=""
        aria-hidden="true"
        className="w-full h-full object-cover object-[center_58%]"
      />
      <div className="absolute inset-0 bg-surface/70" />
    </div>

    <div className="relative z-10 container-site">
      <motion.div
        className="text-center"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.55, ease: 'easeOut' }}
      >
        <motion.p
          className="inline-flex items-center gap-2 rounded-full border border-accent/40 bg-accent-strong/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-accent-soft mb-4"
          animate={{ boxShadow: ['0 0 0 rgba(88,101,242,0)', '0 0 24px rgba(88,101,242,0.25)', '0 0 0 rgba(88,101,242,0)'] }}
          transition={{ duration: 2.8, repeat: Infinity, ease: 'easeInOut' }}
        >
          Offre unique · Prix fixe
        </motion.p>
        <h1 className="heading-display text-balance mb-4">
          Création de <span className="text-accent-soft whitespace-nowrap">site internet</span> pour <span className="whitespace-nowrap">auto-entrepreneurs</span> et TPE
        </h1>
        <p className="text-balance text-2xl md:text-4xl font-extrabold text-fg mb-4">
          Un site pro qui vous <span className="text-accent-soft">amène des clients</span>
        </p>
        <p className="text-xl md:text-2xl font-semibold text-fg mb-5">
          <span className="text-accent-soft">{formatEuro(SETUP_PRICE)}</span> à la mise en ligne, puis{' '}
          <span className="text-accent-soft">{formatEuro(MONTHLY_PRICE)}/mois</span>
        </p>
        <p className="text-fg text-base md:text-lg max-w-3xl mx-auto mb-8">
          Auto-entrepreneurs, artisans, TPE et PME : nous créons, mettons en ligne et mettons à jour votre site internet. Basés à Viry, près de Genève, rendez-vous sur place ou en visio.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3 mb-10">
          {HERO_BADGES.map(({ label, icon: Icon }) => (
            <span
              key={label}
              className="flex items-center gap-1.5 bg-white/10 border border-line-strong rounded-full px-4 py-1.5 text-sm text-fg"
            >
              <Icon className="h-4 w-4 text-accent-soft" /> {label}
            </span>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-4">
          <motion.div whileHover={{ scale: 1.03, y: -2 }} whileTap={{ scale: 0.98 }}>
            <OfferWhatsAppCta location="hero" className={`${PRIMARY_CTA_CLASS} w-full`} />
          </motion.div>
          <motion.div whileHover={{ scale: 1.03, y: -2 }} whileTap={{ scale: 0.98 }}>
            <OfferFormCta location="hero" className={`${SECONDARY_CTA_CLASS} w-full`} />
          </motion.div>
        </div>
      </motion.div>
    </div>
  </div>
);

export default OfferHero;
